import AppConstants from '../config/app.constants';

let HoldVerifyService = function ($http, $q) {

    let all = (search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/hold-verify`, {
                params: {
                    search,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let get = (id) => {
        return $http
            .get(AppConstants.api + `/hold-verify/${id}`)
            .then((res) => {
                return res.data
            })
    };

    return {
        all,
        get
    };
};

HoldVerifyService.$inject = ['$http', '$q']

export default HoldVerifyService;


// WEBPACK FOOTER //
// ./client/app/services/hold-verify.service.js